// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var ElectricMetersService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ElectricMetersService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get electric-meters list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    ElectricMetersService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "condo-structures/electric-meters-list", params);
    };
    /**
     * Get an exportation file of electric-meters
     *
     * @since 1.0.0
     */
    ElectricMetersService.prototype.getExport = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'condo-structures/electric-meters-list-export', params, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get all ElectricMeters of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    ElectricMetersService.prototype.getElectricMeters = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/electric-meters")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    ElectricMetersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ElectricMetersService_Factory() { return new ElectricMetersService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: ElectricMetersService, providedIn: "root" });
    return ElectricMetersService;
}());
export { ElectricMetersService };
